import {  Text, IconButton } from "@nike/eds";
import React from "react";

type Props = { pageData: { currentPage: number, totalPages: number }, handlePageChange: (page: number) => void };


export const Pagination: React.FC<Props> = ({ pageData = { currentPage: 0, totalPages: 0 }, handlePageChange }) => {

    return (
        <nav aria-label="Pagination" className="flex-33">
            <ul className="eds-flex eds-flex eds-flex--align-items-center">
                <li>
                    <IconButton
                        label='previous page'
                        aria-label="previous page"
                        data-testid="previous-page"
                        onClick={() => handlePageChange(pageData.currentPage - 1)}
                        disabled={pageData.currentPage === 1}
                        icon={'CaretLeft'}
                        variant="ghost"
                    />
                </li>
                <li>
                    <Text className="select_font" style={{fontSize: '16px'}}>
                        Page {pageData.currentPage} of {pageData.totalPages == 0 ? 1 : pageData.totalPages}
                    </Text>
                </li>
                <li>
                    <IconButton
                        label='next page'
                        aria-label="next page"
                        data-testid="next-page"
                        onClick={() => handlePageChange(pageData.currentPage + 1)}
                        disabled={pageData.currentPage === pageData.totalPages}
                        icon={'CaretRight'}
                        variant="ghost"
                    />
                </li>
            </ul>
        </nav>
    );
}